function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Select, Button, Form, Input, Image, Upload, Modal, InputNumber, Tooltip, Flex, Descriptions, Switch, Radio, Space, DatePicker, Alert, notification } from 'antd';
import ImgCrop from 'antd-img-crop';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import { PlusCircleFill, Youtube } from "react-bootstrap-icons";
import Common from "../includes/Common";
import { useNavigate } from 'react-router-dom';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var AddEvent = function AddEvent(_ref) {
  var handler = _ref.handler,
    organization = _ref.organization;
  var navigate = useNavigate();
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    info = _Modal$useModal2[0].info,
    contextHolder = _Modal$useModal2[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    payForm = _Form$useForm2[0];
  var _Form$useForm3 = Form.useForm(),
    _Form$useForm4 = _slicedToArray(_Form$useForm3, 1),
    form = _Form$useForm4[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    free = _useState6[0],
    setFree = _useState6[1];
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    attenderOut = _useState8[0],
    setAttenderOut = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    cover = _useState10[0],
    setCover = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    longitude = _useState12[0],
    setLongitude = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    latitude = _useState14[0],
    setLatitude = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    catList = _useState16[0],
    setCatList = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    eventMode = _useState18[0],
    setEventMode = _useState18[1];
  var _useState19 = useState(5000),
    _useState20 = _slicedToArray(_useState19, 2),
    maximumAudience = _useState20[0],
    setMaximumAudience = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    paymentOptions = _useState22[0],
    setPaymentOptions = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isPaymentOptionsLoading = _useState24[0],
    setIsPaymentOptionsLoading = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showPaymentBox = _useState26[0],
    setShowPaymentBox = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    formValues = _useState28[0],
    setFormValues = _useState28[1];
  var props = {
    listType: "picture-card",
    onPreview: function onPreview(file) {
      return false;
    },
    onRemove: function onRemove(file) {
      setCover(null);
    },
    beforeUpload: function beforeUpload(file) {
      setCover(file);
      return false;
    },
    accept: ".png,.jpg,.jpeg",
    maxCount: 1
  };
  var getEventPrice = function getEventPrice(maxAud) {
    var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GN";
    var price = 0;
    if (countryCode == "GN") {
      switch (maxAud) {
        case 1000:
          price = 2500000;
          break;
        case 5000:
          price = 5000000;
          break;
        case 10000:
          price = 9000000;
          break;
        case 50000:
          price = 15000000;
          break;
      }
      return (price / 1000).toLocaleString("Fr");
    }
  };
  var processEvent = function processEvent(values) {
    var pg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var mobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    if (pg) formData.append("pg", pg);
    if (mobile) formData.append("mobile", mobile);
    formData.append("ticket_print_quantity", values.ticket_print_quantity);
    formData.append('label', values.label);
    formData.append("maximum_audience", maximumAudience);
    formData.append('event_category_id', values.event_category_id);
    formData.append('contact', values.contact);
    formData.append('place', values.place);
    formData.append('description', values.description);
    formData.append('starts_at', values.starts_at);
    formData.append('ends_at', values.ends_at);
    formData.append('place', values.place);
    formData.append('longitude', longitude);
    formData.append('latitude', latitude);
    formData.append('organization_id', organization.id);
    formData.append('attender_out', attenderOut);
    formData.append('free', free);
    formData.append('image_file', cover);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addevent', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 201) {
        window.location.href = response.data.payment_url;
      }
      if (response.data.status == 200) {
        handler();
        navigate('/home/compte/m-events');
      }
      if (response.data.status < 200 || response.data.status > 299) setErrorMessage(response.data.message);
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur s\'est produite, ' + error.message);
    });
  };
  var onFinish = function onFinish(values) {
    setFormValues(values);
    if (values.ticket_print_quantity > 0) setShowPaymentBox(true);else processEvent(values);
  };
  useEffect(function () {
    form.setFieldsValue({
      email: '',
      address: '',
      ticket_print_quantity: "0"
    });
    axios.get("".concat(Common.baseApiUrl, "geteventcategories")).then(function (response) {
      if (response.data.status == 200) {
        setCatList([]);
        response.data.categories.forEach(function (c) {
          setCatList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
      } else {
        notification.error({
          message: "Erreur",
          description: "Une erreur est survenue pendant le chargement des données"
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue"
      });
    });
  }, []);
  /* useEffect(() => {
       if(eventMode == 0 )
           info({
               title: <b>Mode libre !</b>,
               content: <p>Gérez votre évènement en mode libre. Créez votre évènement, imprimez et vendez vos tickets vous mêmes. Controlez les entrées en flashant les tickets. Payez en fonction du nombre de place limite. Entrez les informations et finalisez le paiement.</p>
           })
       if(eventMode == 1 )
               info({ 
                   title: <b>Mode partage !</b>, 
                   content: <p>Gérez votre évènement en mode partage. Créez votre évènement, rendez les tickets disponible sur notre site et dans vos points. Controlez les entrées en flashant les tickets.</p>
               })    
   }, [eventMode]);*/
  useEffect(function () {
    setIsPaymentOptionsLoading(true);
    payForm.setFieldsValue({
      mobile: Common.currentUser.mobile.slice(3)
    });
    axios.get(Common.baseApiUrl + "getpgs").then(function (response) {
      if (response.data.status == 200) {
        response.data.pgs.forEach(function (pg) {
          setPaymentOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: pg.id,
              label: /*#__PURE__*/_jsxs(Flex, {
                gap: "small",
                justify: "center",
                align: "center",
                vertical: true,
                children: [/*#__PURE__*/_jsx(Image, {
                  preview: false,
                  width: "90px",
                  src: "drawables/" + pg.logo
                }), /*#__PURE__*/_jsx("b", {
                  children: pg.label
                })]
              })
            }]);
          });
        });
        if (response.data.pgs.length > 0) payForm.setFieldsValue({
          pg: response.data.pgs[0].id
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setIsPaymentOptionsLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      background: "#F5F2EB",
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
      borderRadius: "6px",
      padding: "10px",
      paddingBottom: "4px !important"
    },
    children: [/*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "middle",
      form: form,
      onFinish: onFinish,
      autoComplete: "off",
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          banner: true,
          closable: true,
          style: {
            marging: '5px 0px',
            fontSize: '14px'
          },
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Nbre tickets \xE0 imprimer",
            name: "ticket_print_quantity",
            rules: [{
              required: true,
              message: "Veuillez choisir une option"
            }],
            children: /*#__PURE__*/_jsx(Tooltip, {
              trigger: ['focus'],
              title: "Saisir le nombre de ticket papier \xE0 commander. Payez instantanement avec votre moyen de paiement.",
              placement: "topLeft",
              classNames: {
                root: 'numeric-input'
              },
              children: /*#__PURE__*/_jsx(InputNumber, {
                step: 500,
                defaultValue: 0,
                controls: true,
                style: {
                  width: "150px"
                }
              })
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Nbre places limite",
            name: "max_audience",
            rules: [{
              required: true,
              message: "Veuillez choisir une optionå"
            }],
            children: /*#__PURE__*/_jsx(Select, {
              placeholder: "Choisir le nombre de ticket limite",
              onChange: function onChange(v) {
                setMaximumAudience(v);
              },
              options: [{
                label: "Limiter à 500 Tickets",
                value: 500
              }, {
                label: "Limiter à 1 000 Tickets",
                value: 1000
              }, {
                label: "Limiter à 5 000 Tickets",
                value: 5000
              }, {
                label: "Limiter à 10 000 Tickets",
                value: 10000
              }, {
                label: "Limiter à 50 000 Tickets",
                value: 50000
              }, {
                label: "Limiter à 100 000 Tickets",
                value: 100000
              }, {
                label: "Limiter à 500 000 Tickets",
                value: 500000
              }, {
                label: "Limiter à 1 000 000 Tickets",
                value: 1000000
              }]
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 4,
          xs: 4,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Image/Affiche",
            children: /*#__PURE__*/_jsx(ImgCrop, {
              aspect: 16 / 9,
              rotationSlider: true,
              children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    padding: "40px 120px"
                  },
                  children: /*#__PURE__*/_jsx(PlusCircleFill, {
                    size: 18
                  })
                })
              }))
            })
          })
        }), /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Form.Item, {
            size: "large",
            name: "label",
            label: "Nom de l'\xE9v\xE8nement",
            rules: [{
              required: true,
              message: "Veuillez entrer le nom de l'évènement"
            }],
            children: /*#__PURE__*/_jsx(Input, {
              maxLength: 64,
              showCount: true,
              placeholder: "Saisir un nom"
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            size: "large",
            name: "event_category_id",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Select, {
              options: catList,
              placeholder: "Choisir une cat\xE9gorie"
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "starts_at",
            label: "Date pr\xE9vue",
            children: /*#__PURE__*/_jsx(DatePicker, {
              style: {
                width: "100%"
              },
              size: "large",
              showTime: true
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "place",
            label: "Lieu",
            children: /*#__PURE__*/_jsx(Input, {
              maxLength: 24,
              showCount: true,
              placeholder: "Entrez le lieu"
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "contact",
            label: "Contact infos",
            children: /*#__PURE__*/_jsx(Input, {
              placeholder: "Entrez un num\xE9ro pour infos"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Autoriser-vous les sorties ?",
            children: /*#__PURE__*/_jsx(Switch, {
              checkedChildren: "Oui",
              unCheckedChildren: "Non",
              onChange: function onChange(checked) {
                setAttenderOut(checked == true ? 1 : 0);
              }
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          xs: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Entr\xE9e gratuite ?",
            children: /*#__PURE__*/_jsx(Switch, {
              checkedChildren: "Oui",
              unCheckedChildren: "Non",
              onChange: function onChange(checked) {
                setFree(checked == true ? 1 : 0);
              }
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: catList.length == 0,
          loading: isFormLoading,
          type: "primary",
          size: "large",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "Finaliser"
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(Modal, {
      open: showPaymentBox,
      footer: null,
      onCancel: function onCancel() {
        setShowPaymentBox(false);
      },
      title: /*#__PURE__*/_jsx("b", {
        children: "Validation du paiement"
      }),
      destroyOnClose: true,
      width: {
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%'
      },
      children: [/*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Choisir votre moyen de paiement"
        })
      }), /*#__PURE__*/_jsxs(Form, {
        form: payForm,
        layout: "vertical",
        onFinish: function onFinish(values) {
          var pg = values.pg;
          var mobile = values.mobile;
          processEvent(formValues, pg, mobile);
        },
        children: [/*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Descriptions, {
            bordered: true,
            column: 1,
            title: /*#__PURE__*/_jsx("b", {
              children: "Infos commande"
            }),
            items: [{
              key: 1,
              label: /*#__PURE__*/_jsx("b", {
                children: "Forfait"
              }),
              children: /*#__PURE__*/_jsxs("span", {
                children: ["Naatou event - Forfait ", maximumAudience]
              })
            }, {
              key: 2,
              label: /*#__PURE__*/_jsx("b", {
                children: "Prix"
              }),
              children: /*#__PURE__*/_jsxs("span", {
                children: [maximumAudience == 1000 && /*#__PURE__*/_jsx("b", {
                  children: getEventPrice(1000)
                }), maximumAudience == 5000 && /*#__PURE__*/_jsx("b", {
                  children: getEventPrice(5000)
                }), maximumAudience == 10000 && /*#__PURE__*/_jsx("b", {
                  children: getEventPrice(10000)
                }), maximumAudience == 50000 && /*#__PURE__*/_jsx("b", {
                  children: getEventPrice(50000)
                })]
              })
            }]
          })
        }), /*#__PURE__*/_jsx(Row, {
          className: "d-flex justify-content-center",
          children: /*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            sm: 10,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "pg",
              children: /*#__PURE__*/_jsx(Radio.Group, {
                options: paymentOptions
              })
            })
          })
        }), /*#__PURE__*/_jsx(Row, {
          className: "d-flex justify-content-center",
          children: /*#__PURE__*/_jsxs(Col, {
            lg: 6,
            md: 6,
            sm: 10,
            children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Alert, {
                banner: true,
                closable: true,
                style: {
                  marging: '5px 0px',
                  fontSize: '14px'
                },
                message: errorMessage,
                type: "error",
                showIcon: true
              })
            }), /*#__PURE__*/_jsxs(Space.Compact, {
              children: [/*#__PURE__*/_jsx(Form.Item, {
                label: "Votre num\xE9ro mobile",
                name: "mobile",
                rules: [{
                  required: true,
                  message: "Veuillez entrer un numéro mobile"
                }],
                children: /*#__PURE__*/_jsx(Input, {
                  width: "210px"
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                label: " ",
                children: /*#__PURE__*/_jsx(Button, {
                  loading: isFormLoading,
                  type: "primary",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Payer"
                  })
                })
              })]
            })]
          })
        })]
      })]
    })]
  });
};
export default AddEvent;